<template>
  <div class="parameters">
    <div class="parameters-user-input">
      <p class="demonstration">logo</p>
      <div class="underline"></div>
      <ParameterUpload :jsonCode="jsonCode" :isLogo="true" />
    </div>
    <div class="parameters-user-input">
      <p class="demonstration">font color</p>
      <div class="underline"></div>
      <div class="el-color-picker-container">
        <span class="el-color-picker-pound-sign">#</span>
        <div>
          <span class="el-color-picker-hex">{{ displayHex(jsonCode.FontColor) }}</span>
          <div class="underline"></div>
        </div>
        <el-color-picker v-model="jsonCode.FontColor"></el-color-picker>
      </div>
    </div>
    <div class="parameters-user-input">
      <p class="demonstration">background image</p>
      <div class="underline"></div>
      <ParameterUpload :jsonCode="jsonCode" :isBackground="true" />
    </div>
    <div class="parameters-user-input">
      <p class="demonstration">background color</p>
      <div class="underline"></div>
      <div class="el-color-picker-container d-flex">
        <span class="el-color-picker-pound-sign">#</span>
        <div>
          <span class="el-color-picker-hex">{{ displayHex(jsonCode.BackColor) }}</span>
          <div class="underline"></div>
        </div>
        <el-color-picker v-model="jsonCode.BackColor"></el-color-picker>
      </div>
    </div>
  </div>
</template>

<script>
  import VueBase64FileUpload from 'vue-base64-file-upload';
  import ParameterUpload from './ParameterUpload.vue';
  export default {
    components: {
    VueBase64FileUpload,
    ParameterUpload
  },
    methods: {
      displayHex(string) {
        return string.slice(1).toUpperCase()
      }
    },
    props: {
      jsonCode: Object
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Parameters/Parameters.vue